import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { IMAGEAPI } from "../../BackendConnections";
import UserLayout from "../utils/user/UserLayout";

export const Network = ({ children, profile }) => {
  const userImg = "/assets/images/preview-img.png";

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <UserLayout>
      <div className="network right-section">
        <div className="banner">
          <div className="banner-title-overlay">
          <h5>
                    <span>
                      MY
                      <br />
                      <b>Network</b>
                      <hr className="bannerhr"
                        style={{
                          height: "5px",
                          background: "white",
                          width: "75%",
                        }}
                      />
                    </span>
                  </h5>
            <img
              src="\assets\images\banners\networkIcon.png"
              className="icon-image "
            />
            <div className="col-sm-6 col-12  title-icon-box text-center">
              <div className="picture-area d-flex justify-content-end">
                <div className="profile-upload">
                  <div className="profile-image  ">
                    <div className="profile-overlay" style={{ display:  isMobile ? "none" : "block"}}></div>
                    <div className="img-wrap">
                      <div
                        className="profile-hexagon"
                        // style={{ width: "190px", marginLeft: "40px" }}

                      >
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 120 90"
                        >
                          <defs>
                            <pattern
                              id="imgupload"
                              patternUnits="userSpaceOnUse"
                              width="150"
                              height="100"
                            >
                              <image
                                xlinkHref={
                                  profile.profile_pic && profile.profile_pic
                                    ? IMAGEAPI + profile.profile_pic
                                    : userImg
                                }
                                x="-25"
                                width="150"
                                height="100"
                              ></image>
                            </pattern>
                          </defs>
                          <polygon
                            fill="url(#imgupload)"
                            points="25.457,92.51 0.914,50 25.457,7.49 74.543,7.49 99.086,50 74.543,92.51 "
                          ></polygon>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <img
            className="banner-image"
            src="\assets\images\banners\networkBanner.png"
            alt="Not Found"
          />
        </div>
        {/* <div className="network-banner-banner"> */}
        {/* <img
            src="\assets\images\banners\Asset 1.png"
            alt=""
          /> */}
        {/* <div className="row align-items-end ">
            <div className="col-sm-6 col-12">
              <div className="d-flex title-icon-box">
                <div>
                  <h5 className="title">
                    MY
                    <br />
                    <strong style={{ fontSize: "40px" }}>Network</strong>
                    <hr style={{ height: "10px", background: "white",width:'80%' }} />
                  </h5>
                </div>
                <div>
                  <img
                    className="mb-5 img-fluid"
                    src="\assets\images\banners\networkIcon.png"
                    alt=""
                    style={{ width: "100px", height: "auto" }}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-12  title-icon-box text-center">
              <div className="picture-area d-flex justify-content-end">
                <div className="profile-upload">
                  <div className="profile-image  ">
                  <div className="profile-overlay"></div>
                    <div className="img-wrap">
                      <div
                        className="profile-hexagon"
                        style={{ width: "190px", marginLeft: "40px" }}
                      >
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          viewBox="0 0 120 90"
                        >
                          <defs>
                            <pattern
                              id="imgupload"
                              patternUnits="userSpaceOnUse"
                              width="150"
                              height="100"
                            >
                              <image
                                xlinkHref={
                                  profile.profile_pic && profile.profile_pic
                                    ? IMAGEAPI + profile.profile_pic
                                    : userImg
                                }
                                x="-25"
                                width="150"
                                height="100"
                              ></image>
                            </pattern>
                          </defs>
                          <polygon
                            fill="url(#imgupload)"
                            points="25.457,92.51 0.914,50 25.457,7.49 74.543,7.49 99.086,50 74.543,92.51 "
                          ></polygon>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        {/* </div> */}
        {/* <div className="row mt-5">
          <div className="col-lg-12 col-md-12 col-12">
            <div className="inner-content primary-content">
              <p>
                Invite and grow your energy community network, enhance profile
                and prospects within your own sector discipline and interfacing.
              </p>

              <p>
                Develop your very own Discipline PEER group and improve your
                overall energy sector status.
              </p>
              <p>
                Access <strong>goneet</strong>&nbsp;
                <span
                  style={{
                    background: "#283270",
                    borderRadius: "5px",
                    color: "white",
                  }}
                >
                  {" "}
                  PRO{" "}
                </span>
                &nbsp; to discover your Ranking within your Discipline and use
                your status and transferability to agencies & employers.
              </p>
            </div>
          </div>
          <div className="col-lg-5 col-md-6 col-12">
            <div className="profile-image">
              <div className="profile-overlay"></div>
              <div
                className="profile-hexagon"
                data-img-src="/assets/images/John_brown.jpg"
              >
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 120 90"
                >
                  <defs>
                    <pattern
                      id="imgupload"
                      patternUnits="userSpaceOnUse"
                      width="150"
                      height="100"
                    >
                      <image
                        xlinkHref={
                          profile.profile_pic && profile.profile_pic
                            ? IMAGEAPI + profile.profile_pic
                            : userImg
                        }
                        x="-25"
                        width="150"
                        height="100"
                      ></image>
                    </pattern>
                  </defs>
                  <polygon
                    fill="url(#imgupload)"
                    points="25.457,92.51 0.914,50 25.457,7.49 74.543,7.49 99.086,50 74.543,92.51 "
                  ></polygon>
                </svg>
              </div>
            </div>
          </div>
        </div> */}
        {children}
        <div className="row cm-35 mt-5">
          <div className="col-12">
            <ul className="quick-links ">
              <li className="">
                <Link to="/user/profile">
                  <span className="icon-wrap">
                    <img src="/assets/images/quick-links/profile.svg" alt="" />
                  </span>
                  <label className="blue">
                    MY
                    <br />
                    <strong>Profile</strong>{" "}
                  </label>
                </Link>
              </li>
              <li>
                <Link to="/user/profile-analytics">
                  <span className="icon-wrap">
                    <img
                      src="/assets/images/quick-links/analytics.svg"
                      alt=""
                    />
                  </span>
                  <label className="red">
                    <strong>goneet</strong>
                    <br />
                    <span
                      style={{
                        backgroundColor: "#283270",
                        color: "white",
                        padding: "2px",
                        borderRadius: "5px",
                      }}
                    >
                      PRO
                    </span>
                  </label>
                </Link>
              </li>
              <li className="active">
                <div className="here-menu">
                  <label>YOUR HERE</label>
                  <img src="/assets/images/downround-icon.png" alt="" />
                </div>
                <Link to="/user/network">
                  <span className="icon-wrap">
                    <img
                      src="/assets/images/quick-links/network-active.svg"
                      alt=""
                    />
                  </span>
                  <label className="orange">
                    MY
                    <br />
                    <strong>Network</strong>{" "}
                  </label>
                </Link>
              </li>
              <li>
                <Link to="/user/performance">
                  <span className="icon-wrap">
                    <img
                      src="/assets/images/quick-links/performance.svg"
                      alt=""
                    />
                  </span>
                  <label className="green">
                    MY
                    <br />
                    <strong>Performance</strong>{" "}
                  </label>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </UserLayout>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;

  return {
    user: user,
    profile: profile,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Network);
